export default __webpack_public_path__ + "static/media/sample-processing.82fd7f53.svg";